<template>
  <div class="maglia-or-flag-plus-nome" :title="calciatore.nomeClub">
    <span
      class="club-image"
      :class="{ 'club-image--flag': showFlag }"
      :style="{ backgroundImage: imageUrl ? `url(${imageUrl})` : '' }"
      aria-hidden="true"
    ></span>
    <span class="club-name">{{ nome }}</span>
  </div>
</template>

<script>
import Config from "../../../config-app/config";

export default {
  name: "maglia-or-flag-plus-nome",
  props: {
    calciatore: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    showFlag() {
      return Config.MAGLIA_OR_FLAG === "flag";
    },
    imageUrl() {
      if (!this.calciatore.ID_Club) return "";
      return this.showFlag
        ? `${Config.PUBLIC_DIR}/clubs/flags/flag_${this.calciatore.ID_Club}.png`
        : `${Config.PUBLIC_DIR}/clubs/maglie/400x400/ID_Anno_${Config.ID_ANNO_MAGLIE}/img_scheda_club_${this.calciatore.ID_Club}.png`;
    },
    nome() {
      return this.calciatore.clubAbbr || this.calciatore.abbrClub ||
        this.calciatore.siglaClub ||
        (this.calciatore.nomeClub || "").slice(0, 3).toUpperCase();
    },
  },
};
</script>

<style scoped>
.maglia-or-flag-plus-nome {
  flex: 0 0 30px;
  width: 30px;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1px;
  overflow: hidden;
  flex-direction: column;
}
.club-image {
  flex: 0 0 15px;
  width: 30px;
  height: 15px;
  background-size: 30px 30px;
  background-position: center top;
  background-repeat: no-repeat;
}
.club-image--flag {
  background-size: contain;
  background-position: center;
}
.club-name {
  max-width: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 8px;
  line-height: 1;
  color: rgba(255, 255, 255, 0.76);
  font-weight: 900;
  background: var(--dark_card_btn);
  padding: 1px 2px;
  border-radius: 3px;
  margin-top: -4px;
}
.club-image--flag + .club-name {
  margin-top: 0;
}
</style>
